export default __webpack_public_path__ + "static/media/meus_pedidos.49c8803e.png";